import React from 'react';
import { Lock, Zap, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black py-12 border-t border-white/10" data-id="element-84">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-85">
        <div className="grid md:grid-cols-3 gap-8 mb-12 text-center md:text-left" data-id="element-86">
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-87">
            <Lock className="w-8 h-8 text-neon mb-2" data-id="element-88" />
            <h4 className="font-bold text-lg" data-id="element-89">Compra 100% segura</h4>
            <p className="text-sm text-gray-400" data-id="element-90">
              Tus datos están protegidos y encriptados.
            </p>
          </div>
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-91">
            <Zap className="w-8 h-8 text-neon mb-2" data-id="element-92" />
            <h4 className="font-bold text-lg" data-id="element-93">Acceso inmediato</h4>
            <p className="text-sm text-gray-400" data-id="element-94">
              Recibí el material al instante en tu email.
            </p>
          </div>
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-95">
            <MessageCircle className="w-8 h-8 text-neon mb-2" data-id="element-96" />
            <h4 className="font-bold text-lg" data-id="element-97">Soporte por WhatsApp</h4>
            <p className="text-sm text-gray-400" data-id="element-98">
              Estamos para ayudarte con cualquier duda.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500" data-id="element-99">
          <p data-id="element-100">
            © {new Date().getFullYear()} Pádel Master Pack. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-101">
            <a href="#" className="hover:text-neon transition-colors" data-id="element-102">
              Política de privacidad
            </a>
            <a href="#" className="hover:text-neon transition-colors" data-id="element-103">
              Términos y condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}